export const ANIMATE_CC_ERROR_NAME = 'AnimateCC';
export class AnimateCCError extends Error {
  name = ANIMATE_CC_ERROR_NAME;
}
